import React from "react";
import API from "../../base/API";
import { getUser } from "../../auth/Auth";
import ReactJson from 'react-json-view';
import Chart from "./Chart";
import PDFButton from "./PDFButton";
import Equalizer from "react-equalizer";
import { translate } from "../../base/Translation";

export default class TestResult extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            get_weave_group_results: "/test/fetch/weave_group/results/:weave_group?branch=:branch",
        });

        this.state = {
            branch_results: [],
            chartData: [],
            chartDataSections: []
        }
    }

    componentDidMount() {
        this.api.request({
            cache: false,
            route: "get_weave_group_results",
            params: { weave_group: this.props.test.weave_data.weave_group.id, branch: this.props.test.branch },
            success: function (response) {
                this.processResults(response);
            }.bind(this)
        });
    }

    max100(num) {
        return num > 100 ? 100 : Math.round(num);
    }

    processResults(data) {

        data = data.map((item) => {
            item.name = item.weave_data.name;
            return item;
        })

        this.setState({ branch_results: data });
        this.processStats(data);
        this.processResultsSections(data);
    }

    processStats(data) {
        let chartData = [];

        if (this.props.test.weave_data.req_perc > 0) {
            chartData = [
                { name: translate('Celkový výsledok') },
                { name: translate(' ') }
            ]
        } else {
            chartData = [
                { name: translate(' ') }
            ]
        }

        for (let i = 0; i < data.length; i++) {
            let test = data[i];
            if (this.props.test.weave_data.req_perc > 0) {
                chartData[0][test.name] = this.max100(test.result.percentage);
                if (typeof test.result.form !== "undefined") {
                    chartData[1][test.name] = this.max100(test.result.form.percentage);
                }
            } else {
                if (typeof test.result.form !== "undefined") {
                    chartData[0][test.name] = this.max100(test.result.form.percentage);
                }

            }
        }

        this.setState({ chartData });
    }

    processResultsSections(data) {
        let chartDataSections = [];
        let usedSections = [];

        for (let i = 0; i < data.length; i++) {
            let test = data[i];
            if (typeof test.result.form !== "undefined") {
                for (let key in test.result.form.sections_stats) {
                    let section = test.result.form.sections_stats[key];
                    if (usedSections.indexOf(section.name) > -1) {
                        continue;
                    }
                    let res = { name: section.name };
                    chartDataSections.push(res);
                    usedSections.push(section.name);
                }
            }
        }

        chartDataSections.forEach((result) => {
            for (let i = 0; i < data.length; i++) {
                let test = data[i];
                if (typeof test.result.form !== "undefined") {
                    for (let key in test.result.form.sections_stats) {
                        let section = test.result.form.sections_stats[key];

                        if (section.name === result.name) {
                            result[test.name] = this.max100(section.percentage);
                        }

                    }
                }
            }
        });

        this.setState({ chartDataSections });
    }


    renderOtherCharts() {
        return (
            <div className="row">
                {this.renderBranchFormChart()}
            </div>
        )
    }

    renderFormStats() {

        const form = this.props.test.result.form;
        let sections = Object.keys(form.sections_stats).map(function (key) {
            return form.sections_stats[key];
        });

        return (
            <div className="col-sm-12 col-md-12">
                <table style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}><h4>{translate("Úspešnosť sledovaných oblastí")}</h4></th>
                            <th style={{ width: "15%", textAlign: "right" }}>
                                {/*<h4 style={{ color: form.percentage >= form.min_perc ? "blue" : "red" }}>{form.percentage} % <small>{this.props.test.result.min_success > 0 ? "" : "(min. " + form.min_perc + " %)"}</small></h4>*/}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sections.map((section, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}. {section.name}</td>
                                    <td style={{ textAlign: "right" }}>{this.max100(Math.round(section.percentage)) + " %"}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        );

    }

    renderStatsPanel() {

        return (
            <div className="panel panel-default" style={{ height: "100%" }}>
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="pull-left" /*style={{ color: this.props.test.result.success ? "blue" : "red", fontWeight: "bold", margin: "0", marginTop: "0.5rem" }}*/>
                                <span style={{ paddingRight: "3rem" }}>
                                    {translate("Celkový výsledok MS")}
                                </span>
                                <span>
                                    {this.props.test.result.percentage + " %"}
                                </span>
                            </h4>
                            <PDFButton type="summary" test={this.props.test} />
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    <div className="row">
                        {this.renderFormStats()}
                    </div>
                </div>
            </div>
        )
    }

    renderTestResultsBreakDown() {
        if (getUser().role < 5) {
            return false;
        }

        return (
            <div className="panel panel-default">
                <div className="panel-heading">Breakdown</div>
                <div className="panel-body">
                    {this.renderTestResultsBreakDownTable(this.props.test.result.form)}
                    {this.renderTestResultsJson()}
                </div>
            </div>
        )
    }

    renderTestResultsJson() {
        return (
            <div>
                <h4>JSON Data</h4>
                <ReactJson collapsed={true} src={this.props.test.result} />
            </div>
        )
    }

    renderTestResultsBreakDownTable(data) {
        if (typeof data === "undefined") {
            return false;
        }

        let item = data;

        if (typeof item.sections_stats === "undefined") {
            item = data.form;
        }

        let sections = Object.keys(item.sections_stats).map(function (key) {
            return item.sections_stats[key];
        });

        return (
            <div>

                <table className="table table-bordered" key={item.name}>
                    <thead>
                        <tr>
                            <th>{item.name}</th>
                            <th style={{ width: "15%" }}>Weight</th>
                            <th style={{ width: "15%" }}>Achieved Points</th>
                            <th style={{ width: "15%" }}>Max Points</th>
                            <th style={{ width: "15%" }}>Weighted perc</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sections.map(function (section, index) {
                            /*let groups = Object.keys(section.groups).map(function (key) {
                                return section.groups[key];
                            });*/
                            return (
                                <tr key={index}>
                                    <td>{section.name}</td>
                                    <td>{section.weight} %</td>
                                    <td>{section.achieved_points}</td>
                                    <td>{section.max_points}</td>
                                    <td>{Math.round(section.percentage)} %</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

            </div>
        )

    }

    renderChildRows(parent, rows, level = 0) {

        const childRows = rows.filter(function (row) {
            return row.parent === this;
        }.bind(parent));

        for (let i = 0; i < childRows.length; i++) {
            const row = childRows[i];

            const style = { paddingLeft: ((level + 1) * 10 + "px") };
            const className = "row " + row.id + " parent-" + row.parent;
            const key = i + level + "_" + row.id;

            this.processedRows.push(<div key={key} style={style} className={className}>{row.content()}</div>);
            this.renderChildRows(row.id, rows, level + 1);
        };

        return this.processedRows;
    }

    renderBranchStatsChart() {
        return (
            <div className="panel panel-default" style={{ height: "100%" }}>
                <div className="panel-heading">
                    {translate("História")}
                </div>
                <div className="panel-body">
                    <Chart data={this.state.chartData} bars={this.state.branch_results} />
                </div>
            </div>
        )
    }

    renderBranchFormChart() {
        return (
            <div className="col-sm-12 col-md-6">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        {translate("Úspešnosť sledovaných oblastí")}
                    </div>
                    <div className="panel-body">
                        <Chart data={this.state.chartDataSections} bars={this.state.branch_results} />
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (!this.props.test.result) {
            return;
        }

        return (
            <div>
                <div className="row">
                    <Equalizer>
                        <div className="col-xs-12 col-md-6" style={{ paddingBottom: "30px" }}>
                            {this.renderStatsPanel()}
                        </div>
                        <div className="col-xs-12 col-md-6" style={{ paddingBottom: "30px" }}>
                            {this.renderBranchStatsChart()}
                        </div>
                    </Equalizer>
                </div>
                {this.renderOtherCharts()}
                {/*this.renderTestResultsBreakDown()*/}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/parts/TestResult.jsx